import React, { useEffect, useState } from 'react'
import { Card, Col, Drawer, Row, Tabs, Tooltip } from 'antd'
import WithdrawalComponent from './withdrawalComponent'
import { agentCommissionTransactionFxn } from '../../universityCommission/actions'
import { useDispatch } from 'react-redux'
import { currencySymbols, displayDate, newStringDate } from '../../../components/_utils/appUtils'
import CommStudentForAgent from '../../universityCommission/drawers/commStudentForAgent'
import { countryList } from '../../login/action'
import _ from 'lodash'
import moment from 'moment'
import BonusDetailsDrawer from '../../universityCommission/drawers/bonusDetailsDrawer'
import WithdrawalIssueDrawer from './withdrawalIssueDrawer'
import ViewWithdrawalIssueModal from './viewWithdrawalIssueModal'

const { TabPane } = Tabs

let agentCommissionInit = {
  visible: false,
  record: {}
}
const ListRecords = (props) => {
  let { countryId, events, agentId } = props
  let [transactionData, setTransactionData] = useState([])
  let dispatch = useDispatch()
  useEffect(() => {
    loadTransactionList()
  }, [countryId && agentId])

  const loadTransactionList = async () => {
    let params = {
      sortField: '_id',
      sortOrder: 'descend',
      countryId: countryId,
      results: 100000,
      agentId: agentId
    }
    if (agentId) {
      let { data } = await dispatch(agentCommissionTransactionFxn({ ...params, regExFilters: [] }))
      setTransactionData(data)
    } else {
      setTransactionData([])
    }

  }

  return (
    <>
      <Row className={'header'}>
        <Col span={4}>Date</Col>
        <Col span={12}>Transaction/Reference</Col>
        <Col span={4}>Debit</Col>
        <Col span={4}>Credit</Col>
      </Row>
      {transactionData && transactionData.length ?
        transactionData.map((item) => {
          let {
            transactionType,
            totalCommission,
            totalApprovedByAdminCommission,
            countryId,
            withdrawalId,
            invoiceNo,
            withdrawalIssueId
          } = item
          return (
            <Row key={item._id}>
              <Col span={4} className={'dateBox'}>
                {newStringDate(item.date)}
              </Col>
              <Col span={12}>
                {item.transactionType === 'Credit' ?
                  <>
                    {invoiceNo}
                  </> :
                  <>
                    {
                      withdrawalId && withdrawalId.account ?
                        <div>
                          Acc no
                          : {withdrawalId.account.accountNo} ({withdrawalId.account.bankName})

                          {withdrawalId.isProceed ?
                            <div className={'withdrawal_proceed_link'}>
                              <Tooltip title={'Swift copy will be uploaded soon'}>
                                Funds transferred to your account
                              </Tooltip>
                            </div> :
                            <div>
                              {withdrawalId.withdrawalReleaseDate ?
                                <div className={'font12 colorDarkPrimary'}>Withdrawal Release Date
                                  : {displayDate(withdrawalId.withdrawalReleaseDate)}</div> : null}
                            </div>
                          }
                        </div> : null
                    }
                  </>
                }

                {item.transactionType == 'Credit' ? <>
                  <div>
                    {item.type == 'Bonus' ? <Tooltip title={'View Details'}>
                        <a className='btn btn-default btn-xs font12' onClick={() => {
                          events.showBonusDetails(item)
                        }}>
                          <img src='../uniBtn/eye.png' alt='' className={'eyeBtn'}
                               style={{ height: 14 }} /> View
                        </a>
                      </Tooltip> :
                      <Tooltip title={'View Student List'}>
                        <a className='btn btn-default btn-xs font12' onClick={() => {
                          events.showAgentCommissionDrawer(item)
                        }}>
                          <img src='../uniBtn/eye.png' alt='' className={'eyeBtn'}
                               style={{ height: 14 }} /> View
                        </a>
                      </Tooltip>}
                  </div>
                </> : ''}

                {item.transactionType == 'Debit' ? <>
                  <div className={'font12'}>
                    {
                      withdrawalId && withdrawalId.receipt && withdrawalId.receipt.url ?
                        <div>
                          <a href={withdrawalId.receipt.url} target={'_blank'}>
                            Download Receipt</a>

                          {withdrawalId.invoice && withdrawalId.invoice.path ?
                            <>
                              <a href={withdrawalId.invoice.path} target={'_blank'}
                                 className={'ml20'}>Download
                                Invoice</a>
                            </>
                            : null}
                          <br />
                          <div className='flex items-center gap-1 text-sm text-gray-700'>
                            <span className='font-medium font12'>Issue / Not Received Funds:</span>
                            <a onClick={() => {
                              events.showWithdrawalIssueDrawer(withdrawalId, item._id)
                            }}
                               className='ml-1 px-3 py-1 rounded bg-blue-600 hover:bg-blue-700 transition-all duration-200'>
                              Raise Request
                            </a>
                            {withdrawalIssueId ?
                              <a className={'btn btn-default roundNew xss font12'} onClick={() => {
                                events.showRaiseRequestObj(withdrawalIssueId)
                              }}>
                                View
                              </a> : null}
                          </div>
                          <div>
                            {withdrawalId.details ? withdrawalId.details : ''}
                          </div>
                        </div> : item.agentCommissionId ?
                        <>
                          <div className={'font12 colorDarkPrimary'}>
                            Advance commission paid on {item && item.advanceCommissionId &&
                          item.advanceCommissionId.casIssueDate ?
                            displayDate(item.advanceCommissionId.casIssueDate) : '--'} (Student
                            - {item && item.studentId && item.studentId.name ? item.studentId.name : '--'})
                          </div>
                          {/*<Tooltip title={'View Student List'}>
                            <a className='btn btn-default btn-xs font12' onClick={() => {
                              events.showAgentCommissionDrawer(item)
                            }}>
                              <img src='../uniBtn/eye.png' alt='' className={'eyeBtn'}
                                   style={{ height: 14 }} /> View
                            </a>
                          </Tooltip>*/}
                        </>
                        :
                        <div>
                          {withdrawalId && !withdrawalId.isProceed &&
                          <div className={'font11'}> Withdrawal : <label
                            className={'label label-warning xs1'}>Pending</label></div>}
                        </div>
                    }
                  </div>
                </> : ''}


              </Col>

              <Col span={4} className={'debit'}>
                {transactionType === 'Debit' ?
                  <span>
                                                    {currencySymbols[countryId]}
                    {totalApprovedByAdminCommission ? totalApprovedByAdminCommission : totalCommission}
                                                </span> : ''}
              </Col>
              <Col span={4} className={'credit'}>
                {transactionType === 'Credit' ?
                  <span>
                                                    {currencySymbols[countryId]}
                    {totalApprovedByAdminCommission ? totalApprovedByAdminCommission : totalCommission}
                                                </span> : ''}
              </Col>

            </Row>
          )
        }) : null}
    </>
  )
}

const TransactionListForAccountant = (props) => {
  let { visible, onClose, countryId, refreshPage, agentId } = props
  let [selectedCountry, setSelectedCountry] = useState('')
  let [visibleWithdrawal, setVisibleWithdrawal] = useState(false)
  let [activeTab, setActiveTab] = useState('1')
  const [agentCommissionState, setAgentCommissionState] = useState(agentCommissionInit)
  const [countryData, setCountryData] = useState([])
  const [countryIdArr, setCountryIdArr] = useState([])
  const [refreshKey, setRefreshKey] = useState(moment())
  const [bonusDetails, setBonusDetails] = useState({
    bonus: {}, visible: false
  })
  let [visibleWithdrawalIssueDrawer, setVisibleWithdrawalIssueDrawer] = useState({
    visible: false,
    record: {},
    agentCommissionId: ''
  })
  let [raiseRequestObj, setRaiseRequestObj] = useState({
    visible: false,
    record: {}
  })

  useEffect(() => {
    loadAllCountry()
  }, [countryId])
  const loadAllCountry = async () => {
    let { data } = await (countryList({
      results: 10,
      active: true,
      countryName: ['Canada', 'UK', 'Australia', 'Germany', 'Canada Onshore'],
      select: ['countryName', 'flag'],
      sortField: '_id',
      sortOrder: 'ascend',
      _id: countryId
    }))
    let defaultCountry = countryId ? countryId : data[0]._id.toString()
    let countryIdArr = []
    _.each(data, (item) => {
      if (item && item._id) {
        countryIdArr.push(item._id.toString())
      }
    })
    setCountryIdArr(countryIdArr)
    let indexVal = countryIdArr.indexOf(defaultCountry)
    setActiveTab((indexVal + 1).toString())
    setCountryData(data)
    setSelectedCountry(defaultCountry)
  }

  const events = {
    showWithdrawal: () => {
      setVisibleWithdrawal(true)
    },
    hideWithdrawal: () => {
      setVisibleWithdrawal(false)
      setRefreshKey(moment())
      refreshPage()
      // tableRef.current.reload()
    },
    showAgentCommissionDrawer: (record) => {
      record.agentCommissionId = record._id
      setAgentCommissionState({
        visible: true,
        record: record
      })
    },
    hideAgentCommissionDrawer: () => {
      setAgentCommissionState({
        visible: false,
        record: {}
      })
    },
    reload: () => {
    },
    chooseTab: (index) => {
      let newIndex = index - 1
      let indexVal = countryIdArr[newIndex]
      setActiveTab(index)
      setSelectedCountry(indexVal)
    },
    showBonusDetails: (data) => {
      setBonusDetails({
        bonus: data,
        visible: true
      })
    },
    hideBonusDetails: () => {
      setBonusDetails({
        bonus: {},
        visible: false
      })
    },
    showWithdrawalIssueDrawer: (record, agentCommissionId) => {
      setVisibleWithdrawalIssueDrawer({
        visible: true,
        record: record,
        agentCommissionId
      })
    },
    hideWithdrawalIssueDrawer: () => {
      setVisibleWithdrawalIssueDrawer({
        visible: false,
        record: {},
        agentCommissionId: ''
      })
      setRefreshKey(moment())
      refreshPage()
    },
    showRaiseRequestObj: (record) => {
      setRaiseRequestObj({
        visible: true,
        record: record
      })
    },
    hideRaiseRequestObj: () => {
      setRaiseRequestObj({
        visible: false,
        record: {}
      })
    }

  }

  return (
    <>
      <Drawer
        title={
          <div>
            Student Commission Transaction list
          </div>
        }
        onClose={() => {
          onClose()
          refreshPage()
        }}
        visible={visible}
        width={'90%'}>
        <div className={'ledgerBox'}>
          <Card bordered={true} key={refreshKey}>
            {countryData && countryData.length ?
              <Tabs defaultActiveKey={activeTab} onTabClick={(item) => {
                events.chooseTab(item)
              }}>
                {countryData.map((item, key) => {
                  return (
                    <TabPane
                      tab={(
                        <div>
                          <img src={item.flag.url} style={{ height: 20 }} />
                          <span style={{ marginLeft: 10 }}>{item.countryName} </span>
                        </div>
                      )} key={(key + 1).toString()}>
                      <ListRecords countryId={item._id} agentId={agentId} events={events} />
                    </TabPane>
                  )
                })}
              </Tabs>
              : null}
          </Card>
        </div>

        {visibleWithdrawal ?
          <WithdrawalComponent
            visible={visibleWithdrawal}
            countryId={selectedCountry}
            onClose={events.hideWithdrawal}
          /> : null}


        {agentCommissionState.visible ?
          <CommStudentForAgent
            visible={agentCommissionState.visible}
            onClose={events.hideAgentCommissionDrawer}
            onSubmit={events.reload}
            record={agentCommissionState.record}
          /> : null}


        {bonusDetails.visible ?
          <BonusDetailsDrawer
            {...bonusDetails}
            onClose={events.hideBonusDetails}
          /> : null}

        {visibleWithdrawalIssueDrawer.visible ?
          <WithdrawalIssueDrawer
            {...visibleWithdrawalIssueDrawer}
            onClose={events.hideWithdrawalIssueDrawer}
          /> : null}

        {raiseRequestObj.visible ?
          <ViewWithdrawalIssueModal
            {...raiseRequestObj}
            onClose={events.hideRaiseRequestObj}
          /> : null}

      </Drawer>
    </>
  )
}
export default TransactionListForAccountant
